import CommunityConnectionsPage from "./communityConnections";

export default CommunityConnectionsPage;